/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'blogger': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#f89029" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M24.57 13.358h-.988a1.4 1.4 0 01-1.4-1.4v-.098a5.88 5.88 0 00-5.88-5.88H11.91a5.88 5.88 0 00-5.88 5.88v8.28a5.88 5.88 0 005.88 5.88h8.181a5.88 5.88 0 005.88-5.88v-5.382a1.4 1.4 0 00-1.4-1.4zm-12.409-2.293h4.686a1.147 1.147 0 110 2.294h-4.686a1.147 1.147 0 110-2.294zm7.778 9.871h-7.777a1.147 1.147 0 110-2.294h7.777a1.147 1.147 0 110 2.294z"/>'
  }
})
